import React, { ReactElement } from "react";
import { BrowserRouter as Router, Switch, Route, HashRouter } from "react-router-dom";
import { ThemeProvider } from "react-jss";
import { mainTheme } from "./theme";
import { Home, BridgeServices } from "./pages";
import "./assets/styles/reset.css";
import "./assets/styles/fonts.css";
import "swiper/swiper-bundle.min.css";

function App(): ReactElement {
  return (
    <ThemeProvider theme={mainTheme}>
      <HashRouter>
        <Switch>
          <Route exact path="/" component={Home}></Route>
          <Route path="/services/:id" component={BridgeServices}></Route>
          <Route path="/about">About Page</Route>
        </Switch>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;
